export default function getDomElementProps(originalProps: any = {}) {
    let domElementProps: any = {};
    Object.keys(originalProps).forEach(propName => {
        if (propName === 'children' || propName.includes('margin') || propName.includes('padding') || propName === 'cols' || propName === 'float')
            return;
        if (propName === propName.toLowerCase())
            domElementProps[propName] = originalProps[propName];
    });
    return domElementProps;
}
